<template>
  <span class="text-danger action" @click="removeCartItem"
    ><button class="btn btn-danger btn-sm" :disabled="!cartItem.delete">
      <i v-if="!loading" class="fas fa-times"></i
      ><i v-if="loading" class="fas fa-spinner fa-spin"></i></button
  ></span>
</template>
<script>
import { deleteCartItem } from "../../services/cart"
import store from "@/store/index"

export default {
  name: "VueExcelCellRemove",
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },

  methods: {
    removeCartItem: async function () {
      if (!this.cartItem.delete) return
      if (this.loading) return
      this.loading = true
      const result = await deleteCartItem({
        cartItemID: this.cartItem.cartItemID,
      })

      if (result.data === "success") {
        store.dispatch("updateCart")
      }
      this.loading = false
    },
  },
}
</script>
<style scoped>
.action {
  cursor: pointer;
}
</style>
